// extracted by mini-css-extract-plugin
export default {"image":"DeviceCard_image__Pymk9","labelText":"DeviceCard_labelText__NvGq+","detailText":"DeviceCard_detailText__3-qWP","deviceNameLink":"DeviceCard_deviceNameLink__TrRMo"};